import { defineStepper, Stepper } from '@stepperize/react';
import {
  additionalContactsValidationSchema,
  jointNomineesValidationSchema,
  nominationWizardCompanyInformationValidationSchema,
  nominationSubmissionValidationSchema,
  yourInformationValidationSchema,
} from '../../models/schemas/nomination-wizard-validation.schema';

export const nominationStepper = defineStepper([
  { id: 'your-information', title: 'Your information', schema: yourInformationValidationSchema },
  { id: 'company-information', title: 'Company information', schema: nominationWizardCompanyInformationValidationSchema },
  { id: 'additional-contact', title: 'Additional contact', schema: additionalContactsValidationSchema },
  { id: 'joint-nominee', title: 'Joint nominee', schema: jointNomineesValidationSchema },
  { id: 'nomination-submission', title: 'Nomination submission', schema: nominationSubmissionValidationSchema },
]);

export type NominationStepId = (typeof nominationStepper.steps)[number]['id'];

export type NominationStepperInstance = Stepper<typeof nominationStepper.steps>;
